import React, { useRef, useState } from 'react';
import './CreateComponent.css';
import Button from '../Button';
import CloseModal from '../CloseModal';
import LeftNavBar from './LeftNav';
import ProgressBarComponent from '../ProgressBar';
import { Container, Navbar, Offcanvas } from 'react-bootstrap';
import NationalEmblem from '@assets/svg_main/national_emblem.svg'
import BreadcrumbComponent from '../Breadcrumb';
import 'bootstrap/dist/css/bootstrap.min.css'
import BackArrowsvg from '@assets/svg_main/BackArrowIconSvg.svg'
import { useSelector } from 'react-redux';
interface CreateProps {
    title?: string;
    breadcrumbItemName?:any;
    onHandleBackArrowButton?:()=>void;
    navItemsModal?: string[];
    activeIndex?:number;
    handleNavClick?:(value:number)=>void;
    formCompleted?:boolean[];
    headerName?:string;
    progressBarPerc?:number;
    contents?: React.ReactNode[];
    handlePrevious?:()=>void;
    handleSubmit?:()=>void;
    finishHandler?:()=>void;
    handleNext?:()=>void;
    handleCancel?:()=>void;
    closeCreateModal?:(value:boolean)=>void;
    closeModal?:boolean;
    checkDataChanged?:any;
}
const CreateCommonComponent: React.FC<CreateProps> = ({
    title,
    breadcrumbItemName,
    onHandleBackArrowButton,
    navItemsModal,
    activeIndex,
    handleNavClick,
    formCompleted,
    headerName,
    progressBarPerc,
    contents,
    handlePrevious,
    handleSubmit,
    finishHandler,
    handleNext,
    handleCancel,
    closeCreateModal,
    closeModal,
    checkDataChanged
}: any) => {
  
  const modalContentRef = useRef<HTMLDivElement>(null);
  const isSelfRegister =useSelector((state:any)=>state.registeration.isSelfRegister);

  const scrollToTop = () =>{
    if(modalContentRef.current)
      {
        modalContentRef.current.scrollTop = 0;
      }
  }
  return (
    <>
       <div className="create_common_component">
      <header className="view-header">
        <div className="logo-wrapper">
          <NationalEmblem className="logo" />
          <div className="name-wrapper">
            <div className="name-wrapper-title">
              JANANI
            </div>
            <div className="name-wrapper-subtext">
              Journey of Antenatal, Natal and Neonatal Integrated Care
            </div>
            <div className="name-wrapper-subtext" style={{ fontWeight: 'bold' }}>Sehat ke Sath, Every Step of Care</div>
          </div>
        </div>
        { !isSelfRegister && <div className="view-route">
          <BreadcrumbComponent
            breadcrumbItemName={breadcrumbItemName}
          />
        </div>}
      </header>
      <main className="view-content">
        <div className="view-profile-buttons">
          <div className="view-profile">
            <Navbar expand="md" bg='light' className='nav_for-mobile'>
              <Container style={{ padding: '0' }}>
                <Navbar.Toggle aria-controls={`basic-navbar-nav`} className='border-0' />
                <Navbar.Offcanvas
                  id={`offcanvasNavbar-expand`}
                  aria-labelledby={`offcanvasNavbarLabel-expand`}
                  placement="start"
                >
                  <Offcanvas.Header closeButton>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <div className='mobile-content'>
                      <LeftNavBar
                        navItemsModal={navItemsModal}
                        activeIndex={activeIndex}
                        onNavClick={handleNavClick}
                        completedIndices={formCompleted}
                      />
                    </div>
                  </Offcanvas.Body>
                </Navbar.Offcanvas>
              </Container>
            </Navbar>
            <Button
              onClick={onHandleBackArrowButton}
              disabled={false}
              id="back-page"
              buttonName={'BACK'}
              colorType={''}
              icon={<BackArrowsvg />}
              iconPosition={'left'}
            />
            <div className="name-type facility">
              <div className="type">{headerName}</div>
            </div>
          </div>
          <div className="header_progress_bar">
            <ProgressBarComponent
              progressBarPercentage={progressBarPerc}
              isLabelNeeded={false}
              className={''}
              variant={'primary'}
            />
          </div>
        </div>
        <div className='content'>
          <LeftNavBar
            navItemsModal={navItemsModal}
            activeIndex={activeIndex}
            onNavClick={handleNavClick}
            completedIndices={formCompleted}
          />
          <div className='tab-content'>
            <div className="main-layout">
              <div className="form-layout" ref={modalContentRef}>
                <div className="form-container">
                  <div className="page_content_span">
                    <span className="page_content_title">
                      {title ? title : (navItemsModal[activeIndex].includes("&") ? navItemsModal[activeIndex].split("&")[0] + ' Details' : navItemsModal[activeIndex])}
                    </span>
                    <span className="page_content_step_count">
                      Step {activeIndex + 1} of {navItemsModal.length}
                    </span>
                  </div>
                  <div
                    id={`form-${activeIndex}`}
                    className="form_content"
                  >
                    {contents[activeIndex]}
                  </div>
                </div>

              </div>

              <div className='action-layout'>
                <button
                  type="button"
                  onClick={()=>{
                    handlePrevious();
                    scrollToTop();
                    }}
                  id={''}
                  className={`previous ${(activeIndex === 0) ? 'disabled' : ''}`}
                  disabled={activeIndex === 0}
                >Previous</button>
                <div className="combine-action">
                <button
                    type="button"
                    onClick={handleSubmit}
                    id={''}
                    className={`save`}
                  >Save</button>
                  <button
                    type="button"
                    onClick={()=>{
                      activeIndex === navItemsModal.length - 1
                      ? finishHandler()
                      : handleNext();
                      scrollToTop();
                    }
                    }
                    id={''}
                    className={`next ${(!formCompleted[activeIndex] || checkDataChanged) ? 'disabled' : ''}`}
                    disabled={!formCompleted[activeIndex] || checkDataChanged}
                  >{activeIndex === navItemsModal.length - 1 ? 'Finish' : 'Next'}</button>
                 
                  <button
                    type="button"
                    onClick={handleCancel }
                    id={''}
                    className={`cancel`}
                  >Cancel</button>
                </div>
              </div>

            </div>

          </div>
        </div>
      </main >
      {closeModal && <CloseModal closeModal={closeCreateModal} showModal={closeModal}/>}
    </div >
    </>
  );
};

export default CreateCommonComponent;
